const ActionTypes = {
  UPDATE_ACTIVE_PROGRESSION_LIST_PROPS_DATA: "activeProgressions/UPDATE_ACTIVE_PROGRESSION_EXPAND_LIST_PROPS_DATA",
  UPDATE_ACTIVE_PROGRESSION_LIST_PROPS: "activeProgressions/UPDATE_ACTIVE_PROGRESSION_EXPAND_LIST_PROPS"
};
export {
  ActionTypes as default
};
//# sourceMappingURL=ActionTypes.js.map
